import {
  CalendarEvent,
  ComplianceCalendarEventsResponse,
} from '@commenda/types/src/compliance-calendar/compliances/calendar-event';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

interface Params {
  companyId: number;
  startDate: string;
  endDate: string;
  enabled?: boolean;
  includeHiddenComplianceTypes?: boolean;
}

export function useComplianceCalendarEvents({
  companyId,
  startDate,
  endDate,
  enabled = true,
  includeHiddenComplianceTypes = false,
}: Params) {
  const key =
    enabled && companyId && startDate && endDate
      ? `compliance-calendar/events?companyId=${companyId}&startDate=${startDate}&endDate=${endDate}${includeHiddenComplianceTypes ? '&includeHiddenComplianceTypes=true' : ''}`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<ComplianceCalendarEventsResponse>(
      key,
      SWRFetcher({ method: 'GET' }, undefined)
    );

  const dates = data?.dates ?? {};
  const events: CalendarEvent[] = Object.values(dates).flatMap((d) => d.events);

  return {
    dates,
    events,
    total: data?.total ?? 0,
    calendarNotGenerated: data?.calendarNotGenerated ?? false,
    isLoading: enabled ? isLoading : false,
    error,
    mutate,
  };
}
